import { setBagCookies } from "..";
import { cache } from "../utils/cache";
import { BagSdkMethod } from "../utils/method-initialiser";

type PublicCheckoutRedirectMethod = (params?: {
  storeUrl?: string;
}) => Promise<void>;
type CheckoutRedirectMethod = BagSdkMethod<PublicCheckoutRedirectMethod>;

const createCheckoutUrlFallback = (countryCode: string) => {
  const { protocol, host } = window.location;
  const secureHost = host.replace(/^www\./, "secure.");
  return `${protocol}//${secureHost}/${countryCode.toLowerCase()}`;
};

export const initialiseCheckoutInitialiser: CheckoutRedirectMethod =
  (config) =>
  async (params = {}) => {
    const { storeUrl } = params;
    const checkoutStoreUrl =
      storeUrl || createCheckoutUrlFallback(config.country);

    const bagSummary = await cache.getSummary(config);
    const bagId = bagSummary?.bagId;

    if (!bagId) {
      throw new Error(
        "Failed to initialise Checkout. The bag ID does not exist",
      );
    }

    const bagSessionToken = bagSummary?.sessionToken;

    if (!bagSessionToken) {
      throw new Error(
        "Failed to remove product. The bag session token does not exist",
      );
    }

    const bagOrigin = bagSummary?.origin;

    if (!bagOrigin) {
      throw new Error(
        "Failed to initialise Checkout. The bag origin does not exist",
      );
    }

    setBagCookies({
      store: config.store,
      country: config.country,
      bagId: bagId,
      bagOrigin: bagOrigin,
      sessionToken: bagSessionToken,
    });

    await cache.signalRefresh(config);

    window.location.href = `${checkoutStoreUrl}/initialise`;
  };
